import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AuthImg({ path, className = "", alt = "", onClick, ...rest }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let alive = true;
    let obj = null;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => { obj = URL.createObjectURL(r.data); if (alive) setUrl(obj); })
      .catch(() => {});
    return () => { alive = false; if (obj) URL.revokeObjectURL(obj); };
  }, [path]);
  if (!url) return <div className={`bg-slate-100 animate-pulse ${className}`} {...rest} />;
  return <img src={url} alt={alt} className={className} onClick={onClick} {...rest} />;
}
